import {ActionIcon, Tooltip} from '@mantine/core';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface CollapseExpandAllButtonProps {
  isExpanded: boolean;
  onToggleExpandAll: () => void;
}

export default function CollapseExpandAllButton({
  isExpanded,
  onToggleExpandAll,
}: CollapseExpandAllButtonProps): JSX.Element {
  return (
    <Tooltip label={isExpanded ? 'Collapse all' : 'Expand all'} withArrow={true} arrowSize={18}>
      <ActionIcon onClick={onToggleExpandAll} aria-label={`${isExpanded ? 'Collapse all' : 'Expand all'}`}>
        <BenchlingIcon icon={isExpanded ? 'arrows-to-line' : 'arrows-from-line'} />
      </ActionIcon>
    </Tooltip>
  );
}
